import { DocumentArrowUpIcon } from "@heroicons/react/24/solid";
import { Box, Dialog } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import { updateSignUpOrigin } from "../../../redux/actions/navbar_action";
import HomepageReplaceResumeDialog from "../../homepage/HomepageReplaceResumeDialog/HomepageReplaceResumeDialog";
import { useHomepageResumeUploadState } from "../../homepage/HomepageResumeUploadContext";
import HomepageResumeUploadedDialog from "../../homepage/HomepageResumeUploadedDialog/HomepageResumeUploadedDialog";
import HomepageDropResume from "../../homepage/HomepageSearch/HomepageDropResume/HomepageDropResume";
import HomepageViewResumeDialog from "../../homepage/HomepageViewResumeDialog/HomepageViewResumeDialog";

const UploadResumeFloating = (props) => {
  const { signupSource, isHomepage = false } = props;
  const { t } = useTranslation();
  const router = useRouter();
  const sharedResume = useHomepageResumeUploadState();
  const [open, setOpen] = useState(false);
  const [localUserResume, setLocalUserResume] = useState(null);
  const userResume = isHomepage ? sharedResume.userResume : localUserResume;
  const setUserResume = isHomepage
    ? sharedResume.setUserResume
    : setLocalUserResume;
  const inputFileRef = useRef(null);
  const openedAsVisitorRef = useRef(false);
  const reduxUserId = useSelector((state) => state?.user?.user?.id);
  const signUpOrigin = useSelector((state) => state?.navbar?.signUpOrigin);
  const dispatch = useDispatch();

  const handleOpen = () => {
    openedAsVisitorRef.current = !reduxUserId;

    sendTrackingEvent({
      event: "CE_floating_resume_button_click",
      page_path: router.asPath,
      signup_source: signupSource || "custom_floating_button",
    });

    if (signupSource) {
      dispatch(updateSignUpOrigin(signupSource));
    }

    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const triggerToast = (isSuccess, content) => {
    if (isSuccess) {
      toast.success(t("homepage.drop_resume_success_message"));
      return;
    }
    if (content) {
      toast.error(content);
      return;
    }
    toast.error(t("homepage.drop_resume_upload_failure_title"));
  };

  useEffect(() => {
    if (open && openedAsVisitorRef.current && reduxUserId) {
      setOpen(false);
    }
  }, [open, reduxUserId]);

  return (
    <>
      {!isHomepage && signUpOrigin !== "company-profile" && (
        <>
          <HomepageResumeUploadedDialog
            inputFileRef={inputFileRef}
            triggerToast={triggerToast}
            userResume={userResume}
            setUserResume={setUserResume}
          />
          <HomepageReplaceResumeDialog
            triggerToast={triggerToast}
            userResume={userResume}
            setUserResume={setUserResume}
          />
          <HomepageViewResumeDialog userResume={userResume} />
        </>
      )}

      <Box
        onClick={handleOpen}
        id="upload-resume-floating-button"
        aria-label="Upload resume (floating)"
        data-testid="resume-upload-floating-btn"
        sx={{
          position: "fixed",
          right: { xs: 16, md: 32 },
          bottom: { xs: 16, md: 32 },
          zIndex: 1300,
          borderRadius: "999px",
          backgroundColor: "#512ACC",
          color: "#FFFFFF",
          px: 3,
          py: 1,
          fontFamily: "Inter, sans-serif",
          fontWeight: 700,
          fontSize: 14,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.25)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {t("homepage.drop_resume_upload_button")}{" "}
        <DocumentArrowUpIcon height="24px" width="19px" />
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        data-testid="resume-upload-floating-dialog"
        fullWidth
        maxWidth="560px"
        PaperProps={{
          sx: {
            width: "auto",
            borderRadius: "16px",
            overflow: "hidden",
            maxHeight: "90vh",
          },
        }}
      >
        <HomepageDropResume
          inputFileRef={inputFileRef}
          triggerToast={triggerToast}
          userResume={userResume}
          setUserResume={setUserResume}
          isFloatingModal
          onCloseModal={handleClose}
        />
      </Dialog>
    </>
  );
};

export default UploadResumeFloating;
